import { Link as WaspRouterLink, routes } from 'wasp/client/router';
import { SignupForm } from 'wasp/client/auth';
import { useQuery, getRegistrationOpen } from 'wasp/client/operations';
import { AuthPageLayout } from './AuthPageLayout';

export function Signup() {
  const { data: regStatus, isLoading } = useQuery(getRegistrationOpen);

  const registrationOpen = isLoading || !regStatus ? true : regStatus.enabled;

  return (
    <AuthPageLayout>
      {!isLoading && !registrationOpen ? (
        <div className="text-center space-y-4">
          <div className="rounded-lg border border-red-200 bg-red-50 p-6 dark:border-red-800 dark:bg-red-950">
            <h2 className="text-lg font-semibold text-red-800 dark:text-red-200 mb-2">
              Registrations Closed
            </h2>
            <p className="text-sm text-red-700 dark:text-red-300">
              {regStatus?.message || 'Registrations are currently closed. Please check back later.'}
            </p>
          </div>
          <span className='text-sm font-medium text-gray-900'>
            Already have an account?{' '}
            <WaspRouterLink to={routes.LoginRoute.to} className='underline'>
              Log in
            </WaspRouterLink>
          </span>
        </div>
      ) : (
        <>
          <SignupForm />
          <br />
          <span className='text-sm font-medium text-gray-900'>
            I already have an account (
            <WaspRouterLink to={routes.LoginRoute.to} className='underline'>
              go to login
            </WaspRouterLink>
            ).
          </span>
          <br />
        </>
      )}
    </AuthPageLayout>
  );
}



